import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserIpService {
  private apiUrl = 'https://api.ipify.org?format=json';

  constructor(private http: HttpClient) {}

  getIpAddress(): Observable<any> {
    return this.http.get<any>(this.apiUrl);
  }
}
